import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ArrowLeft, ArrowRight } from "lucide-react";

const QUOTES = [
  {
    quote:
      "Build Right rebuilt our brand and our pipeline in the same quarter. It's the first agency relationship where the invoice always felt smaller than the return.",
    name: "Sarah Okafor",
    role: "Founder & CEO, Meridian & Co.",
  },
  {
    quote:
      "Twelve months in, our paid program runs at 12x ROAS and organic has become our largest channel. They operate like partners, not vendors — because they are.",
    name: "Daniel Reyes",
    role: "CMO, Aurum Capital",
  },
  {
    quote:
      "The new site won awards, but what I care about is the 4.2x conversion lift. Precision over volume isn't a slogan for them. It's how they work.",
    name: "Priya Natarajan",
    role: "VP Growth, Vertex Labs",
  },
];

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);
  const q = QUOTES[index];

  const go = (d) => {
    setDir(d);
    setIndex((i) => (i + d + QUOTES.length) % QUOTES.length);
  };

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative bg-[#0A1128] py-28 lg:py-36">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-amber-400/90 mb-10"
        >
          Client Voices
        </motion.p>

        <div className="flex justify-center gap-1.5 mb-10" data-testid="testimonial-stars">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={18} className="fill-amber-400 text-amber-400" />
          ))}
        </div>

        <div className="relative min-h-[220px] sm:min-h-[180px]">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.blockquote
              key={index}
              initial={{ opacity: 0, x: 40 * dir }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -40 * dir }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              data-testid="testimonial-quote"
            >
              <p className="font-serif italic text-2xl sm:text-3xl lg:text-4xl leading-snug text-amber-50">
                “{q.quote}”
              </p>
              <footer className="mt-8">
                <p className="font-sans font-semibold text-amber-200">{q.name}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">{q.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-6">
          <button
            data-testid="testimonial-prev-button"
            onClick={() => go(-1)}
            aria-label="Previous testimonial"
            className="h-12 w-12 rounded-full border border-amber-400/30 flex items-center justify-center text-amber-300 hover:bg-amber-400 hover:text-[#060B18] transition-colors duration-300"
          >
            <ArrowLeft size={18} />
          </button>
          <span className="font-mono text-xs tracking-[0.3em] text-slate-500">
            {String(index + 1).padStart(2, "0")} / {String(QUOTES.length).padStart(2, "0")}
          </span>
          <button
            data-testid="testimonial-next-button"
            onClick={() => go(1)}
            aria-label="Next testimonial"
            className="h-12 w-12 rounded-full border border-amber-400/30 flex items-center justify-center text-amber-300 hover:bg-amber-400 hover:text-[#060B18] transition-colors duration-300"
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
